import { Link, useParams } from 'react-router-dom'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { DetailHeader } from '@/components/common/DetailHeader'
import { useRoles } from './hooks'
import { GeneralPanel } from './components/GeneralPanel'
import { VisibilityPanel } from './components/VisibilityPanel'
import { RolePermissionsPanel } from './components/RolePermissionsPanel'

export function RoleDetailPage() {
  const { code } = useParams<{ code: string }>()
  const rolesQ = useRoles()
  const role = rolesQ.data?.find(r => r.code === code)

  if (rolesQ.isLoading) return <div className="p-4">Ładowanie…</div>
  if (!role) {
    return (
      <div className="p-4">
        <p className="text-sm text-red-600">Rola nie znaleziona.</p>
        <Link to="/admin/roles" className="text-sm text-sky-700 underline">← Role i widzialność</Link>
      </div>
    )
  }

  return (
    <div className="flex flex-col w-full h-full">
      <DetailHeader
        title={role.name}
        subtitle={
          <span className="font-mono">
            {role.code} · {role.isActive ? 'aktywna' : 'nieaktywna'}
          </span>
        }
      />

      <Tabs defaultValue="visibility" className="flex-1 flex flex-col gap-0 overflow-hidden">
        <TabsList className="rounded-none w-full justify-start gap-2 px-4 border-b bg-white h-auto">
          <TabsTrigger value="general">Ogólne</TabsTrigger>
          <TabsTrigger value="visibility">Widzialność</TabsTrigger>
          <TabsTrigger value="permissions">Uprawnienia</TabsTrigger>
        </TabsList>

        <TabsContent value="general" className="flex-1 overflow-auto p-4">
          <GeneralPanel role={role} />
        </TabsContent>
        <TabsContent value="visibility" className="flex-1 overflow-auto p-4">
          <VisibilityPanel roleCode={role.code} />
        </TabsContent>
        <TabsContent value="permissions" className="flex-1 overflow-auto p-4">
          <RolePermissionsPanel roleCode={role.code} />
        </TabsContent>
      </Tabs>
    </div>
  )
}
